import { InstagramOnboardingTemplate } from "@/components/Templates";
import { useInstagramOnboardingPage } from "@/hooks/useInstagramOnboardingPage";

export function InstagramOnboardingPage() {
  const onboarding = useInstagramOnboardingPage();

  return <InstagramOnboardingTemplate {...onboarding} />;
}
